<template>
  <div>
    <div>
      <b-tabs size="is-midium" type="is-boxed" :animated="false" vertical>
        <template v-for="item in signCategory">
          <b-tab-item :key="item.label" :label="item.label">
            <template v-for="sign in item.signs">
              <b-tooltip
                type="is-white"
                :label="signInfo(sign)"
                :key="sign.sign"
                :multilined="true"
              >
                <b-button
                  class="button--sign is-size-4 is-size-6-mobile"
                  :class="cuneiformClass"
                  @click="pushSign(sign)"
                >
                  {{ sign.sign }}</b-button
                >
              </b-tooltip>
            </template>
          </b-tab-item>
        </template>
      </b-tabs>
    </div>
  </div>
</template>

<script>
const signtable = require("@/data/syllables_table_.json");
import Syllabic from "../modules/SyllabicValue.js";

import DisplayTransLiteral from "../modules/Transliteral.js";

//ulength returns number of codepoints of str
function ulength(str) {
  return Array.from(str).length;
}

export default {
  data() {
    return {
      text: "",
      picklist: []
    };
  },
  props: {
    level: {
      type: Number,
      default: 0
    },
    cuneiformClass: {
      type: String,
      default: "akkadian"
    },
    transliteralStyle: String
  },
  methods: {
    pushSign(sign) {
      this.$emit("select", sign);
    },

    signInfo(sign) {
      var result = Syllabic(sign.name);
      for (let index = 0; index <= this.level; index++) {
        let phones = sign.transliteral[index];
        if (phones) {
          for (let i = 0; i < phones.length; i++) {
            if (phones[i] == sign.name) continue;
            result +=
              " / " + DisplayTransLiteral(phones[i], this.transliteralStyle);
          }
        }
      }
      return result;
    }
  },

  computed: {
    signs() {
      return signs;
    },

    signCategory() {
      let categories = [
        {
          label: "𒀸",
          min: 1,
          max: 208,
          signs: []
        },
        {
          label: "𒋰",
          min: 209,
          max: 504,
          signs: []
        },
        {
          label: "𒀼",
          min: 505,
          max: 574,
          signs: []
        },
        {
          label: "𒀹",
          min: 575,
          max: 660,
          signs: []
        },

        {
          label: "𒌋",
          min: 661,
          max: 747,
          signs: []
        },
        {
          label: "𒁹",
          min: 748,
          max: 907,
          signs: []
        }
      ];
      for (const key in signtable.signs) {
        let tmp = signtable.signs[key];
        for (const sign in tmp) {
          let info = tmp[sign];

          if ((info.level & [1, 3, 7, 15][this.level]) == 0) continue;
          info.sign = sign;
          if (/^[0-9]+[a-z]?$/.test(info.meszl)) {
            let meszl = Number(info.meszl);

            for (let element in categories) {
              let category = categories[element];

              if (meszl <= category.max && meszl >= category.min) {
                category.signs.push(info);
              }
            }
          }
        }
      }
      categories.forEach(category => {
        category.signs = category.signs.sort(
          (a, b) => Number(a.meszl) - Number(b.meszl)
        );
      });
      return categories;
    }
  }
};
</script>

<style lang="sass">
#Signs
    input
        font-size: 20px
        font-family: sinacherib
button.button--sign
    margin: 2px

.button--pick
    margin: 2px
</style>
